export default "__VITE_ASSET__u2cn8GLS__"